import { render } from "./CompareShelf.vue?vue&type=template&id=70d54609&scoped=true"
import script from "./CompareShelf.vue?vue&type=script&lang=js"
export * from "./CompareShelf.vue?vue&type=script&lang=js"

import "./CompareShelf.vue?vue&type=style&index=0&id=70d54609&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d54609"]])

export default __exports__